var map = {
	"./blog4.jpg": "d2SX",
	"./blog_3_1.jpg": "ffBv",
	"./blog_3_2.jpg": "4Bvl",
	"./blog_3_3.jpg": "G/RO",
	"./blog_5_1.jpg": "2+gD",
	"./blog_5_2.jpg": "xyMI",
	"./blog_new1_acerswift.png": "PyNy",
	"./blog_new1_asus-zenbook.png": "LOBO",
	"./blog_new1_lenovo.png": "92ZW",
	"./blog_new1_lg.png": "TGxJ",
	"./blog_new1_macbookair.jpeg": "IKnM",
	"./blog_new1_macbookair.png": "RHoV",
	"./blog_new2_1.jpg": "1nwr",
	"./blog_new2_2.jpg": "WP7e",
	"./blog_new2_3.jpg": "lox5",
	"./blog_new2_4.jpg": "o5eC",
	"./blog_new2_5.png": "zAsz",
	"./blog_new2_6.jpg": "vfrn",
	"./blog_new6_1.png": "vxos",
	"./blog_new6_2.jpg": "SuQ1",
	"./blog_new7_27-apple-airpods-pro.png": "Cll6",
	"./blog_new7_anker-soundcore.png": "2KUM",
	"./blog_new7_bose-quietcomfort-buds-2.png": "3hjF",
	"./blog_new7_sennheiser-true-wireless-2-12.png": "Uu02",
	"./blog_new7_sony.png": "PbnR",
	"./blog_new9_animals.png": "oYjb",
	"./blog_new9_microsoft-edge.jpg": "h7aS",
	"./blog_news1_asus-zenbook-13-2020.png": "o+Wh",
	"./blog_news1_dell-xps-13.png": "VDFz",
	"./blog_news1_macbook-pro-16-late-2019.png": "HA5T",
	"./blog_news1_surface.png": "YLOV",
	"./blog_news1h_hp-envy-x360.png": "Upoq",
	"./blog_news8.jpg": "Wgn6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ojy8";